<template>
  <a-config-provider
    :locale="locale"
    :theme="{
      token: {
        colorPrimary: '#3842D2',
      },
    }"
  >
    <div style="height: 100%;">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import locale from 'ant-design-vue/es/locale/zh_CN';
export default {
  name: 'App',
  components: {
    
  },
  data() {
    return {
      locale,
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>
